var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "conversations-container flex-grow-1 flex-shrink-0 position-relative",
    },
    [
      _c(
        "div",
        { staticClass: "position-absolute h-100 w-100 d-flex flex-column" },
        [
          _c("filter-component", {
            staticClass: "flex-grow-0 flex-shrink-0 mb-2",
            attrs: { list: _vm.filterList, values: _vm.filters },
            on: { apply: _vm.onFiltersApply },
            scopedSlots: _vm._u([
              {
                key: "buttons",
                fn: function () {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-purple align-self-start ml-1",
                        on: { click: _vm.refreshList },
                      },
                      [
                        _c("i", {
                          staticClass: "fas fa-sync",
                          class: { "fa-spin": _vm.isListRefreshingActive },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.canAddToGroup
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-purple align-self-start ml-1",
                            on: { click: _vm.onAddToGroup },
                          },
                          [_vm._v("\n          Add to group\n        ")]
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "flex-grow-0 flex-shrink-0 search-bar mb-2",
            attrs: { clearable: true, autofocus: true, placeholder: "Search" },
            on: { input: _vm.onPendingSearchChanged },
            model: {
              value: _vm.pendingSearch,
              callback: function ($$v) {
                _vm.pendingSearch = $$v
              },
              expression: "pendingSearch",
            },
          }),
          _vm._v(" "),
          _c("list", {
            ref: "list",
            staticClass: "list flex-grow-1",
            attrs: { url: _vm.url },
            on: {
              "conversation-select": _vm.onSelect,
              "refresh-start": _vm.onListRefreshStarted,
              "refresh-finish": _vm.onListRefreshFinished,
            },
          }),
          _vm._v(" "),
          _vm.canAddToGroup ? _c("add-to-group-dialog-form-wrapper") : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }